export const services = [
  {
    slug: "limpeza",
    number: "01",
    name: "Limpeza",
    icon: "Sparkles",
    description: "Limpeza de casas, apartamentos, escritórios e imóveis, com atenção aos detalhes.",
    detail: "Conte connosco para organizar uma limpeza pontual ou uma intervenção de manutenção da sua propriedade.",
    subservices: ["Limpeza de casa", "Limpeza de apartamento", "Limpeza de escritório", "Limpeza de imóvel"],
    featured: true,
  },
  {
    slug: "reparacoes",
    number: "02",
    name: "Reparações",
    icon: "Wrench",
    description: "Pequenas reparações domésticas e correções para voltar a ter tudo a funcionar.",
    detail: "Explique o que aconteceu e, se possível, envie fotografias. A equipa analisa o pedido e prepara a visita adequada.",
    subservices: ["Pequena reparação", "Portas e ferragens", "Torneiras e sifões", "Paredes e acabamentos"],
    featured: true,
  },
  {
    slug: "montagem",
    number: "03",
    name: "Montagem",
    icon: "PackageOpen",
    description: "Montagem de móveis, prateleiras e outros elementos para a sua casa.",
    detail: "Um móvel novo, uma prateleira ou um suporte pode ficar pronto sem complicações. Envie as medidas ou fotografias quando ajudarem.",
    subservices: ["Montagem de móveis", "Prateleiras e suportes", "Varões e cortinados", "Desmontagem e montagem"],
    featured: true,
  },
  {
    slug: "beleza",
    number: "04",
    name: "Beleza",
    icon: "HeartHandshake",
    description: "Serviços de beleza e cuidados pessoais ao domicílio, mediante disponibilidade.",
    detail: "Indique o cuidado que procura e a zona. Confirmaremos se existe um profissional disponível para a sua necessidade.",
    subservices: ["Cuidados pessoais", "Manicure e pedicure", "Cabeleireiro ao domicílio", "Outro serviço de beleza"],
    featured: false,
  },
  {
    slug: "automovel",
    number: "05",
    name: "Automóvel",
    icon: "CarFront",
    description: "Apoio automóvel no local ou nas proximidades, quando aplicável ao pedido.",
    detail: "Descreva o problema e indique onde se encontra o veículo. A equipa confirmará o tipo de ajuda que pode ser prestada.",
    subservices: ["Apoio no local", "Pequena manutenção", "Limpeza automóvel", "Outro pedido automóvel"],
    featured: false,
  },
  {
    slug: "decoracao",
    number: "06",
    name: "Decoração",
    icon: "Paintbrush",
    description: "Ajuda a pendurar, organizar e transformar pequenos espaços da sua casa.",
    detail: "Desde pendurar quadros a reorganizar uma divisão, descreva o resultado que pretende e avaliaremos o trabalho.",
    subservices: ["Quadros e espelhos", "Cortinados e varões", "Organização de espaços", "Pequeno projeto decorativo"],
    featured: false,
  },
  {
    slug: "jardinagem",
    number: "07",
    name: "Jardinagem",
    icon: "TreePine",
    description: "Manutenção de jardins, cortes, limpeza e cuidados básicos de jardinagem.",
    detail: "Partilhe o tamanho aproximado do espaço e o que precisa de ser feito para receber uma orientação adequada.",
    subservices: ["Manutenção de jardim", "Corte e poda", "Limpeza exterior", "Cuidados básicos"],
    featured: false,
  },
  {
    slug: "instalacoes",
    number: "08",
    name: "Instalações",
    icon: "PlugZap",
    description: "Instalação de equipamentos, acessórios, prateleiras, eletrodomésticos e outros elementos.",
    detail: "Antes da visita, recolhemos os detalhes essenciais para levar o profissional e as ferramentas mais adequadas.",
    subservices: ["Equipamento doméstico", "Iluminação", "Prateleiras e suportes", "Acessórios e fixações"],
    featured: true,
  },
  {
    slug: "lavandaria",
    number: "09",
    name: "Lavandaria",
    icon: "Shirt",
    description: "Serviços de lavandaria e cuidados de roupa, de acordo com a necessidade apresentada.",
    detail: "Diga-nos o volume e o tipo de roupa. A equipa confirmará o serviço e a forma mais conveniente de o realizar.",
    subservices: ["Lavagem de roupa", "Engomadoria", "Cuidados de roupa", "Outro serviço de lavandaria"],
    featured: false,
  },
  {
    slug: "manutencao",
    number: "10",
    name: "Manutenção",
    icon: "Settings2",
    description: "Manutenção preventiva e geral de casas, apartamentos, lojas e outras propriedades.",
    detail: "Para uma necessidade isolada ou um plano de manutenção, explique o estado do imóvel e os pontos a acompanhar.",
    subservices: ["Manutenção geral", "Manutenção preventiva", "Imóvel para arrendamento", "Pequenos trabalhos"],
    featured: true,
  },
  {
    slug: "mudancas",
    number: "11",
    name: "Mudanças",
    icon: "Truck",
    description: "Ajuda a transportar, manusear e reorganizar móveis durante uma mudança.",
    detail: "Indique os locais, pisos, elevador e volume aproximado para podermos preparar melhor o pedido de visita.",
    subservices: ["Ajuda na mudança", "Manuseamento de móveis", "Desmontagem e transporte", "Reorganização de espaço"],
    featured: true,
  },
  {
    slug: "controlo-de-pragas",
    number: "12",
    name: "Controlo de Pragas",
    icon: "Bug",
    description: "Soluções para lidar com pragas em casas e propriedades, sujeitas a avaliação.",
    detail: "Descreva os sinais encontrados e a dimensão aproximada do espaço. O pedido será encaminhado para avaliação.",
    subservices: ["Avaliação de pragas", "Tratamento de insetos", "Prevenção", "Outro problema"],
    featured: false,
  },
  {
    slug: "impermeabilizacao",
    number: "13",
    name: "Impermeabilização",
    icon: "Droplets",
    description: "Ajuda a prevenir infiltrações, humidade e entrada de água em diferentes superfícies.",
    detail: "Fotografias do local podem ajudar a perceber a origem e a preparar uma visita de diagnóstico.",
    subservices: ["Infiltrações", "Varandas e terraços", "Juntas e selagens", "Prevenção de humidade"],
    featured: false,
  },
];

export const getService = (slug) => services.find((service) => service.slug === slug);
